import { Box, Stack } from '@mui/material';
import {
  useBrandOrdersQuery,
  useBrandPointsSummaryQuery,
  useBrandSignupAggregateQuery,
  useBrandSignupTimeSeriesQuery,
  useBrandSummaryQuery,
} from 'api/reports-service/reports-service';
import JobsStatusGate from 'components/jobs-status-gate/jobs-status-gate.component';
import {
  LPComparisonDateParams,
  LoyaltyPerformanceParamsDiff,
} from 'api/reports-service/reports-service.types';
import BrandLoyaltyAPIDetailsDrawer from 'components/drawers/brand-loyalty-api-details-drawer/brand-loyalty-api-details-drawer.component';
import { useDrawer } from 'components/drawers/inc-drawer/inc-drawer.hooks';
import LoyaltyPerformanceHeader from 'components/loyalty-performance-header/loyalty-performance-header.component';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import {
  MultipleSearchQueryProvider,
  SearchParamsProvider,
} from 'components/search/search.context';
import {
  useSearchParams,
  useSearchQuery,
} from 'components/search/search.hooks';
import { useBrandLoyaltyOverviewSearchParams } from '../loyalty-performance-report.hooks';
import BrandOrders from './brand-orders/brand-orders.component';
import BrandSignupAggregate from './brand-signup-aggregate/brand-signup-aggregate.component';
import BrandSignupTimeSeries from './brand-signup-time-series/brand-signup-time-series.component';
import BrandSummaryCards from './brand-summary-cards/brand-summary-cards.component';
import BrandPointsSummaryCards from './brand-points-summary-cards/brand-points-summary-cards.component';

const filteredSearchParams: LoyaltyPerformanceParamsDiff<LPComparisonDateParams> =
  [
    'granularity',
    'storeIds',
    'count',
    'page',
    'offerIds',
    // 'offerstatus',
    'datatype',
    'offerdatatype',
    // 'campaignId',
    'sortBy',
    'sortDirection',
    'offertype',
  ];

const SearchParamsWrapper = () => {
  const searchParams = useSearchParams(useBrandLoyaltyOverviewSearchParams());
  return (
    <SearchParamsProvider value={searchParams}>
      <BrandLoyaltyOverview />
    </SearchParamsProvider>
  );
};

const BrandLoyaltyOverview = () => {
  const { open, close, isOpen } = useDrawer();
  const brandSignupTimeSeries = useSearchQuery(useBrandSignupTimeSeriesQuery, {
    filteredSearchParams: [
      'comparisonstartdate',
      'comparisonenddate',
      ...filteredSearchParams,
    ],
  });
  const brandOrders = useSearchQuery(useBrandOrdersQuery, {
    filteredSearchParams: [
      'comparisonstartdate',
      'comparisonenddate',
      ...filteredSearchParams,
    ],
  });
  const brandSignupAggregate = useSearchQuery(useBrandSignupAggregateQuery, {
    filteredSearchParams: [
      'comparisonstartdate',
      'comparisonenddate',
      ...filteredSearchParams,
    ],
  });
  const brandSummaryCards = useSearchQuery(useBrandSummaryQuery, {
    filteredSearchParams,
  });
  const brandPointsSummaryCards = useSearchQuery(useBrandPointsSummaryQuery, {
    filteredSearchParams,
  });

  return (
    <Stack marginTop={2}>
      <MultipleSearchQueryProvider
        value={{
          queries: {
            brandSignupTimeSeries,
            brandOrders,
            brandSignupAggregate,
            brandSummaryCards,
            brandPointsSummaryCards,
          },
        }}
      >
        <SearchToolbar />
        <Stack>
          <LoyaltyPerformanceHeader open={open} />
        </Stack>
        <Box display="grid" gap={2}>
          <Box
            display="grid"
            gridTemplateColumns={{ xs: '1fr', xl: '1fr 4fr' }}
            gap={2}
          >
            <Box display="grid" height={{ xs: 300, xl: 'auto' }}>
              <BrandSignupAggregate />
            </Box>
            <Box
              display="grid"
              gridTemplateColumns={{
                xs: '1fr',
                sm: 'repeat(2, 1fr)',
                xl: 'repeat(5, 1fr)',
              }}
              gridAutoRows="1fr"
              gap={2}
            >
              <BrandSummaryCards />
            </Box>
          </Box>
          <Box
            display="grid"
            gridTemplateColumns={{ xs: '1fr', xl: '2fr 1fr' }}
            gridAutoRows={{ xs: 300, xl: 500 }}
            gap={2}
          >
            <BrandSignupTimeSeries />
            <BrandOrders />
          </Box>

          <Box
            display="grid"
            gridTemplateColumns={{
              xs: '1fr',
              sm: 'repeat(2, 1fr)',
              xl: 'repeat(5, 1fr)',
            }}
            gap={2}
          >
            <BrandPointsSummaryCards />
          </Box>
        </Box>
      </MultipleSearchQueryProvider>
      <BrandLoyaltyAPIDetailsDrawer isOpen={isOpen} close={close} />
    </Stack>
  );
};

export default function GatedPage() {
  return (
    <JobsStatusGate>
      <SearchParamsWrapper />
    </JobsStatusGate>
  );
}
